module.exports = __webpack_public_path__ + "img/location.592e70f9.svg";